import { useParams } from 'react-router-dom';
import api from '../../services/api';
import { useQuery } from "@tanstack/react-query";

export const useGetProduct = ({id = null}) => {
    const { vendorId } = useParams();
    const fetchData = async () => {
        const { data } = id ? await api.get(`/vendors/${vendorId}/product/${id}/`) : { data: null };
        return data;
    };
    return useQuery({
        queryKey: ['product', id],
        queryFn: fetchData,
        enabled: !!id,
    });
};

export const useGetProducts = () => {
    const { vendorId, groupID } = useParams();
    const fetchData = async () => {
        const { data } = ( groupID ) ? await api.get(`/vendors/${vendorId}/products/${groupID}`) : {data:[]}
        return data;
    };
    return useQuery({ queryKey: ['products', groupID], queryFn: fetchData, enabled: true });
};
